/* eslint-disable jsx-a11y/anchor-is-valid */
import { useAuth0 } from "@auth0/auth0-react";
import { Avatar } from "@material-ui/core";
import RightArrowSvg from "assets/icons/svg/RightArrowSvg";
import { InputField, LabelField, RadioButton, HintField } from "components";
import { useFormik } from "formik";
import { useSearch } from "hook";
import MemberService from "Lib/API/Member";
import FinanceService from "Lib/API/Finance";
import React, { useEffect, useState } from "react";
import Select, { components } from "react-select";
import styled from "styled-components";
import { DatePickerField } from "_metronic/_partials/controls";
import "../index.scss";
import { invoicePayment } from "pages/ValidationSchema";
import { toastr } from "react-redux-toastr";
const selectControlStyles = {
  backgroundColor: "#F3F6F9",
  borderColor: "#F3F6F9",
  color: "#3F4254",
  transition:
    "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  paddingTop: "8px",
  paddingBottom: "8px",
  cursor: "pointer",
};
const colourStyles = {
  control: (styles) => ({
    ...styles,
    ...selectControlStyles,
  }),
};
const Body = styled.div`
  width: 25%;
  background: #fff;
  min-width: 400px;
  max-height: 1201px;
  padding: 13px 13px 13px 0px;
  margin-top: 20px;
  margin-inline-end: 20px;
`;

const Title = styled.div`
  font-size: 15px;
  color: #3f4255;
`;

const ChequeDetails = styled.div`
  display: flex;
  padding: 8px;
  cursor: pointer;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  border: 1px solid #b5b5c3;
  border-radius: 6px;
  transition: all 0.2s ease;
`;
const radioList = [
  { name: "Cash", value: "cash" },
  { name: "Card", value: "card" },
  { name: "Cheque", value: "cheque" },
  { name: "ACH", value: "ach" },
];
const PaymentForm = ({ setAmount, submit, toValue, setToValue, ...props }) => {
  const [loading, setLoading] = React.useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [search, setSearch] = useState(undefined);
  const [card, setCard] = useState(null);
  const [contactsList, setContactsList] = React.useState([]);
  const { searchAction } = useSearch({ action: setSearch });
  const [localFormat, setLocalFormat] = useState(false);

  const initialValues = {
    to: "",
    member_id: "",
    payment_date: "",
    account_id: "",
    noOfPayment: "",
    amount: "",
    readioOption: "",
    account_number: "",
    bank_number: "",
    cheque_number: "",
    cheque_date: "",
  };
  ///////////////////////////////////////////////////////////////////////
  /////////////////////////////GET CARDS ///////////////////////////////
  React.useEffect(() => {
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      await FinanceService.getCardsById(toValue.account_id, token)
        .then((res) => {
          if (res) {
            setCard(res[0]);
          }
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);
        });
    }
    if (toValue?.account_id) fetchMyAPI();
  }, [toValue]);
  ///////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////
  const enableLoading = (value) => {
    setLoading(value);
  };
  useEffect(() => {
    async function fetchMyAPI() {
      enableLoading(true);
      const token = await getAccessTokenSilently();
      await MemberService.getContacts(token, search).then((res) => {
        if (res?.contacts) {
          res.contacts.map((item) => {
            item.label = item?.first_name + " " + item?.last_name;
            item.value = item._id;
            return item;
          });
          setContactsList(res?.contacts);
        }
        enableLoading(false);
      }).catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
    }
    fetchMyAPI();
  }, [search, getAccessTokenSilently]);

  const formik = useFormik({
    isInitialValid: false,
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: invoicePayment,
    onSubmit: async (values) => {
      props.setSubmitLoading(true);
    },
  });
  useEffect(() => {
    if (submit) formik.handleSubmit();
  }, [submit]);

  useEffect(() => {
    props.setValid(formik.isValid);
  }, [formik]);
  const formatOptionLabel = ({ label, id, profile_img }) => {
    return (
      <div className="dropdown-container" key={id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          {profile_img ? (
            <img height={15} width={15} src={profile_img} alt="" />
          ) : (
            <Avatar style={{ width: 15, height: 15 }}>
              {label?.charAt(0)}
            </Avatar>
          )}
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };
  useEffect(() => setAmount(formik?.values?.amount), [formik?.values?.amount]);
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <RightArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };

  return (
    <Body>
      <div style={{ marginInlineStart: 25, marginTop: 15, marginBottom: 15 }}>
        <Title>Payment Preferences</Title>
        <div
          style={{
            width: "72%",
          }}
        >
          <LabelField style={{ marginTop: 20 }} title={"To"} />
          <Select
            {...{
              formik,
              name: "to",
              checkValidation: true,
            }}
            onInputChange={(text) => searchAction(text)}
            classNamePrefix="react-select"
            formatOptionLabel={formatOptionLabel}
            options={contactsList}
            isLoading={loading}
            styles={colourStyles}
            onChange={(value) => setToValue(value)}
            value={toValue}
            components={{ DropdownIndicator }}
          />
        </div>
        <div
          style={{
            padding: 10,
            border: "1px solid #B5B5C3 ",
            marginTop: 10,
            borderRadius: 6,
            width: "72%",
          }}
        >
          {!toValue ? (
            <h4>choose a member</h4>
          ) : (
            <div>
              Paying for:
              <p>
                {`${toValue?.label} ${
                  toValue?.location?.formattedAddress
                    ? toValue?.location?.formattedAddress
                    : ""
                } ${toValue?.city ? toValue?.city : ""} ${
                  toValue?.zip_code ? toValue?.zip_code : ""
                } ${toValue?.phone_number ? toValue?.phone_number : ""}`}
              </p>
            </div>
          )}
        </div>
        <DatePickerField
          {...{
            formik,
            name: "payment_date",
            title: "Payment Date",
          }}
          myStyle={{ width: "72%", height: 48 }}
          labelStyle={{ marginTop: 10 }}
          value={formik.values?.payment_date}
          onChange={(e) => {
            formik.setFieldValue(`payment_date`, e.target.value);
            setLocalFormat(true);
          }}
          localFormat={localFormat}
        />
        <InputField
          mandatory={false}
          {...{
            type: "number",
            formik,
            title: "Payment Number",
            name: "noOfPayment",
            placeholder: "1",
            checkValidation: true,
          }}
          style={{ width: "72%" }}
        />
        <InputField
          mandatory={false}
          {...{
            type: "number",
            formik,
            title: "Amount",
            name: "amount",
            placeholder: "1",
            checkValidation: true,
          }}
          style={{ width: "72%" }}
        />
        <RadioButton
          title="Payment Method"
          list={radioList}
          card={card ? card.last4 : null}
          {...{
            formik,
            name: "readioOption",
          }}
        />
        {formik?.touched["readioOption"] && formik?.errors["readioOption"] ? (
          <HintField error={formik?.errors["readioOption"]} />
        ) : null}
        {formik.values.readioOption === "cheque" && (
          <ChequeDetails>
            <DatePickerField
              {...{
                formik,
                name: "cheque_date",
                title: "Cheque Date",
              }}
              myStyle={{ marginInlineEnd: 10, height: 48 }}
              value={formik.values?.cheque_date}
              onChange={(e) => {
                formik.setFieldValue(`cheque_date`, e.target.value);
                setLocalFormat(true);
              }}
              localFormat={localFormat}
            />
            <InputField
              mandatory={false}
              {...{
                type: "number",
                formik,
                title: "Cheque Number",
                name: "cheque_number",
                placeholder: "1",
                checkValidation: true,
              }}
              formStyle={{ width: "46%" }}
            />
            <InputField
              mandatory={false}
              {...{
                type: "number",
                formik,
                title: "Bank Number",
                name: "bank_number",
                placeholder: "1",
                checkValidation: true,
              }}
              formStyle={{ width: "46%", marginInlineEnd: 10 }}
            />
            <InputField
              mandatory={false}
              {...{
                type: "number",
                formik,
                title: "Account Number",
                name: "account_number",
                placeholder: "1",
                checkValidation: true,
              }}
              formStyle={{ width: "46%" }}
            />
          </ChequeDetails>
        )}
      </div>
    </Body>
  );
};

export default PaymentForm;
